import HomeView from "@/views/HomeView.vue";
import { useI18n } from "vue-i18n";
import ErrorsHelper from "@/_helpers/ErrorsHelper.js";

export default class MasterCommunicationHandler {
  constructor(componentReference) {
    this.componentReference = componentReference;
    this.entryPoint = null;
    this.childI18n = null;
    this.vueI18n = useI18n();
  }

  SearchReference(reference) {
    const searchEvent = new CustomEvent("amr-search", {
      detail: {
        reference: reference,
        // we may add other things later
      },
    });
    window.dispatchEvent(searchEvent);
  }

  ListenForSearchResults(callback = null) {
    window.addEventListener("child-amr-search-result", (e) => {
      if (callback != null) callback(e.detail);
    });
  }

  Register(module, callback = null) {
    if (!this.validateModule(module)) return;
    if (module.isIgnored) return;

    window.addEventListener(`register-${module.moduleName}`, (e) => {
      if (e.detail.i18n) {
        this.childI18n = e.detail.i18n;
        this.UpdateTranslations();
      }
      this.entryPoint = e.detail.entryPoint;
      this.AppendRoutes(e.detail.sideBarMenu, e.detail.moduleName);
      this.TrackEntryPoints(e.detail.moduleName, module);

      if (callback !== null) {
        callback();
        callback = null;
      }
    });
  }

  validateModule(module) {
    return (
      module &&
      module !== null &&
      module.moduleName &&
      module.moduleName !== null
    );
  }
  Destroy() {
    window.removeEventListener("register-amr-module", null);
  }

  UpdateTranslations() {
    if (this.childI18n !== null) {
      for (let availableLocale of this.childI18n.availableLocales) {
        const childMessages = this.childI18n.getLocaleMessage(availableLocale);
        if (childMessages.sideMenu) {
          this.vueI18n.mergeLocaleMessage(availableLocale, {
            sideBar: childMessages.sideMenu,
          });
        }
        if (childMessages.searchPagesResults) {
          this.vueI18n.mergeLocaleMessage(availableLocale, {
            searchPagesResults: childMessages.searchPagesResults,
          });
        }
      }
    }
  }

  TrackEntryPoints(moduleName, module) {
    this.componentReference.rootElements =
      this.componentReference.rootElements.map((rootEl) => {
        if (rootEl.id === moduleName) {
          rootEl.entryPoint = this.entryPoint;
          rootEl.isReact = module.isReact ?? false;
        }
        return rootEl;
      });
  }

  AppendRoutes(sideBarMenuItems, moduleName) {
    if (!this.componentReference.auxMenu) return;
    let sideBar = [];
    sideBarMenuItems.forEach((menuItem) => {
      if (
        menuItem.href !== undefined &&
        menuItem.href !== "/" &&
        this.componentReference.auxMenu.filter((el) => {
          return el.href == menuItem.href;
        }).length == 0
      ) {
        menuItem.href =
          menuItem.href !== ""
            ? "/" + this.componentReference.$realm + menuItem.href
            : menuItem.href;
        menuItem.exact = false;
        menuItem.external = false;
        menuItem.moduleName = moduleName;
        let newMenuItem = { ...menuItem };
        if (menuItem.tcode) {
          newMenuItem.title = this.entryPoint.$t(`sideMenu.${menuItem.tcode}`);
        }
        this.PushChildRoutes(newMenuItem);
        if (this.PushRoute(newMenuItem)) {
          sideBar.push(newMenuItem);
        }
      }
    });

    this.pushHiddenRoutes(moduleName);
    this.componentReference.auxMenu =
      this.componentReference.auxMenu.concat(sideBar);
  }

  PushRoute(menuItem) {
    if (menuItem.href == "") return true;

    let slaveRoute = this.resolveSlaveRoute(menuItem.href);
    //hasAtLeastOneRole
    const isAuthorized = this.canLoadRoute(slaveRoute);
    if (slaveRoute !== null) {
      const route = {
        name: slaveRoute.name,
        path: this.isAlreadyPrefixed(slaveRoute)
          ? slaveRoute.path
          : "/" + this.componentReference.$realm + slaveRoute.path,
        component: HomeView,
        meta: slaveRoute.meta,
        props: { route: slaveRoute.path, moduleName: menuItem.moduleName },
      };
      this.componentReference.$router.addRoute(route);
      if (!isAuthorized) return false;
      return true;
    } else {
      ErrorsHelper.menuItemIgnored(menuItem);
      return false;
    }
  }

  removeOptionalParams(route) {
    // Split the route string by '/'
    const parts = route.split("/");
    // Filter out parts that are not optional parameters
    const filteredParts = parts.filter((part) => !part.endsWith("?"));
    // Join the filtered parts back together with '/'
    const result = filteredParts.join("/");
    // Ensure there's no trailing '/'
    return result.endsWith("/") ? result.slice(0, -1) : result;
  }

  canLoadRoute(route) {
    if (route) {
      if (route.meta == null || route.meta == undefined) return true;
      if (route.meta.roles == null || route.meta.roles == undefined)
        return true;
      if (route.meta.roles.includes("guest")) return true;
      return this.componentReference.$jwt.hasAtLeastOneRole(route.meta.roles);
    }
    return false;
  }

  isAlreadyPrefixed(route) {
    return route.name && route.name.startsWith("prefixed_");
  }

  resolveSlaveRoute(href) {
    for (let route of this.entryPoint.$router.getRoutes()) {
      const computedRoute = "/" + this.componentReference.$realm + route.path;
      if (route.path === href || computedRoute == href) return route;
      else {
        const cleanedRoute = this.removeOptionalParams(href);
        const cleanedComputed = this.removeOptionalParams(computedRoute);
        const cleanedOriginal = this.removeOptionalParams(route.path);
        if (cleanedComputed == cleanedRoute || cleanedOriginal == cleanedRoute)
          return route;
      }
    }
    return null;
  }

  resolveMasterRoute(href) {
    for (const route of this.componentReference.$router.getRoutes()) {
      if (route.path === href) return route;
    }
    return null;
  }

  pushHiddenRoutes(moduleName) {
    this.entryPoint.$router.options.routes.forEach((route) => {
      const masterRoute = this.resolveMasterRoute(route.path);

      if (masterRoute === null) {
        const menuItem = {
          href: route.path,
          moduleName: moduleName,
        };
        this.PushRoute(menuItem);
      }
    });
  }

  PushChildRoutes(menuItem) {
    if (menuItem.child && menuItem.child.length > 0) {
      let indexesToDelete = [];
      menuItem.child.forEach((child, index) => {
        child.exact = false;
        child.external = false;
        child.moduleName = menuItem.moduleName;
        if (!this.PushRoute(child)) {
          indexesToDelete.push(index);
        }
        child.href = "/" + this.componentReference.$realm + child.href;
      });
      for (const i of indexesToDelete) menuItem.child.splice(i, 1);
    }
  }
}
